import {DatePipe} from '@angular/common';

export class Race {
  name: string;
  shortName: string;
  place: string;
  coordinates: string;
  logo: string;
  info: string;
  timeZone: string;
  id?: string;
  date: string;
  accomodation: string;
  signingFrom: string;
  signingTo: string;
  pages = [];

  constructor(
    name = 'Slavomil Rusinak Cup',
    shortName = 'SRC',
    place = 'Spisska Bela',
    coordinates = 'XXX',
    logo = 'YYY',
    timeZone = 'Europe/Slovakia',
    date = new DatePipe('en-US').transform(new Date(), 'dd.MM.yyyy hh:mm:ss'),
    accomodation = 'Penzion Zora',
    signingFrom = new DatePipe('en-US').transform(new Date(), 'dd.MM.yyyy hh:mm:ss'),
    signingTo = new DatePipe('en-US').transform(new Date(), 'dd.MM.yyyy hh:mm:ss'),
    pages= [{icon: 'info', label: 'Details'}, {icon: 'assignment', label: 'Propositions'}, {icon: 'local_hotel', label: 'Accommodation'}, {icon: 'border_color', label: 'Sign in'}, {icon: 'supervised_user_circle', label: 'Registered crews'}]
  ) {
    this.name = name;
    this.shortName = shortName;
    this.place = place;
    this.coordinates = coordinates;
    this.logo = logo;
    this.timeZone = timeZone;
    this.date = date;
    this.accomodation = accomodation;
    this.signingFrom = signingFrom;
    this.signingTo = signingTo;
    this.pages = pages;
  }
}

export class Article {
  title: string;
  image: string;
  author: string;
  content: string;
  timeZone: string;
  published: string;

  constructor(
    title = 'Season 2021 can officially begun!',
    image = 'SRC',
    author = 'Peter Rusinak',
    content = 'XXX',
    timeZone = 'Europe/Slovakia',
    published = new DatePipe('en-US').transform(new Date(), 'dd.MM.yyyy hh:mm:ss'),
  ) {
    this.title = title;
    this.image = image;
    this.author = author;
    this.content = content;
    this.timeZone = timeZone;
    this.published = published;
  }
}
